import o from"styled-components";import{COLORS as t}from"../../../../../constants/Theme.js";const e=o.div`
	display: flex;
	padding: 8px 16px;
	flex-direction: row;
	align-items: center;
	justify-content: end;
	box-shadow: 0px -2px 8px rgba(0, 0, 0, 0.12);
	background: ${t.surface.standard};
`;export{e as BottomBarContainer};
